import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
   root: {
      display: 'flex',
   },
   textCenter: {
      textAlign: 'center',
   },
   positionRelative: {
      position: 'relative',
   },
   grow: {
      // flexGrow: 1,
   },

   menuButton() {
      return {
         flip: false, // disable auto switching
         marginRight: theme.spacing(2),
      };
   },
   hide: {
      display: 'none',
   },
   drawer: {
      width: '248px',
      flexShrink: 0,
   },
   drawerPaper: {
      width: '248px',
      border: 'none',
   },

   sidebar: {
      width: '80%',
      maxWidth: 360,
      backgroundColor: theme.palette.primary,
      color: theme.palette.text.secondary,
   },
   sidebarNestedItem: {
      paddingLeft: theme.spacing(4),
      color: theme.palette.text.primary,
      backgroundColor: 'none',
   },
   sidebarListItem: {
      fontWeight: 'bold',
      width: theme.spacing(28.5),
      margin: theme.spacing(1, 1.2),
   },
   sidebarListItemActive: {
      width: theme.spacing(28.5),
      margin: theme.spacing(0, 1.2),
      backgroundColor: '#069BFF',
      borderRadius: '5px',

      '&:hover': {
         backgroundColor: '#069BFF',
         color: '#ffffff',
      },
   },
   sidebarListItemIcon: {
      fontWeight: '12px',
      minWidth: theme.spacing(5),
      color: '#ffffff',
   },
   childListItems: {
      color: '#069BFF',
   },
   sidebarIcon: {
      fontWeight: '12px',
      color: theme.palette.text.secondary,
      minWidth: theme.spacing(5),
   },
   sidebarActiveColor: {
      color: '#ffffff',
      fontWeight: 'bold',
      backgroundColor: 'none',
   },
   bold: {
      fontWeight: 'bold',
   },
   modalTitle: {
      margin: 0,
      padding: theme.spacing(2),
   },
   modalTitleCloseBtn: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
   },
}));

export { useStyles };
